import React from "react";
import styled from "styled-components";

interface CheckboxOptionProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  children: React.ReactNode;
}

const CheckboxOptionContainer = styled.div`
  display: flex;
  align-items: baseline;
  break-inside: avoid;
  margin-bottom: 0.75rem;
`;

const JargonCheckbox = styled.label`
  position: relative;
  padding-left: 36px;
  cursor: pointer;
  display: inline-block;
  line-height: 24px;
  user-select: none;
  flex: 1 1 auto;

  sup {
    line-height: 0;
    position: relative;
    vertical-align: baseline;
    top: -0.5em;
  }
`;

const HiddenInput = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: absolute;
  opacity: 0;
  margin: 0;
`;

const CheckboxIndicator = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  border: 2px solid var(--jargon-primary);
  background-color: var(--control-background);
  box-sizing: border-box;

  &::after {
    content: "";
    position: absolute;
    left: 7px;
    top: 2px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    opacity: 0;
  }

  ${HiddenInput}:checked + & {
    background-color: var(--jargon-primary);
    border-color: var(--jargon-primary);

    &::after {
      opacity: 1;
    }
  }
`;

const CheckboxOption: React.FC<CheckboxOptionProps> = ({ id, children, ...rest }) => {
  return (
    <CheckboxOptionContainer>
      <JargonCheckbox htmlFor={id}>
        <HiddenInput type="checkbox" id={id} {...rest} />
        <CheckboxIndicator />
        {children}
      </JargonCheckbox>
    </CheckboxOptionContainer>
  );
};

export default CheckboxOption;